import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from '../../../auth/services/auth/auth.service';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {TenantService} from '../../../auth/services/tenant/tenant.service';
import {GenericHttpService} from './genericHttpService';
import {AiAssistantRegistrationService} from '../../../ai-assistant/services/ai-assistant-registration.service';

@Injectable({
  providedIn: 'root'
})
export class JWTInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
              private tenantService: TenantService,
              private registrationTokenProvider: AiAssistantRegistrationService,
              private apiService: ApiService) {
    this.authService = authService;
    this.tenantService = tenantService;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startsWithAccountApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.accountApiClient, request.url);
    const startsWithTenantApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.tenantApiClient, request.url);
    const startsWithApplicationApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.applicationApiClient, request.url);
    const startsWithAIApiClientUrl = this.isStartingWithClientBaseUrl(this.apiService.aiAssistantApiClient, request.url);

    const shouldInjectJwt = startsWithAccountApiClientUrl || startsWithTenantApiClientUrl || startsWithApplicationApiClientUrl || startsWithAIApiClientUrl;
    const shouldInjectTenantCode = startsWithApplicationApiClientUrl || startsWithAIApiClientUrl;
    const shouldInjectRegistrationToken = startsWithAIApiClientUrl;

    const headers: any = {};
    if (shouldInjectJwt) {
      headers.Authorization = 'Bearer ' + this.authService.jwtToken;
    }
    if (shouldInjectTenantCode) {
      headers.tenantcode = this.tenantService.tenantDto.tenant.id;
    }
    if (shouldInjectRegistrationToken && this.registrationTokenProvider.registrationToken) {
      headers.registrationtoken = this.registrationTokenProvider.registrationToken;
    }

    if (shouldInjectJwt || shouldInjectTenantCode) {
      request = request.clone({
        setHeaders: headers
      });
    }

    return next.handle(request);
  }

  isStartingWithClientBaseUrl(client: GenericHttpService, url: string): boolean {
    if (!client) {
      return false;
    }
    if (!client.baseUrl) {
      return false;
    }
    if (url.startsWith(client.baseUrl)) {
      return true;
    }
    return false;
  }
}


